<div fxLayout="row" fxLayoutAlign="space-around start" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="40px" fxLayoutGap.sm="30px" fxLayoutAlign.xs="center center" fxLayoutAlign.sm="center center" style="margin-top: 10px;">
    <app-about-web-side-bar></app-about-web-side-bar>
<div fxFlex class="genericContent p-3 p-sm-5 p-md-5 p-lg-5 p-xl-5 p-xxl-5 border-shadow m-0 sabadell-Container" id="divMain">
        <router-outlet name="aboutWebRouter" (activate)="onActivate($event)"></router-outlet>
</div>
<br>